module.exports = "/images/cta-bg.png?4062c1e082746297bd72bcd0e3edff37";